import React, { useContext } from 'react';
import { AuthContext } from 'providers/authorization-context';
import { isAuthorizedToRender } from 'utils/localization/utils';
import { omit } from 'lodash';
export const AuthorizationWrapper = (props) => {
    const { altComponent = null, children } = props;
    const auth = useContext(AuthContext);
    const authorized = isAuthorizedToRender(props, auth);
    if (!authorized)
        return altComponent;
    return React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, Object.assign(Object.assign({}, child.props), omit(props, [
                'children',
                ...Object.keys(AuthorizationWrapper.defaultProps),
            ])));
        }
        return child;
    });
};
AuthorizationWrapper.defaultProps = {
    requiredRoles: [],
    excludedUserTypes: [],
    excludedRegions: [],
};
